import React from "react";
import { Navigate } from "react-router-dom";

// Usage: Wrap Any Route Component With ProtectedRoute
const ProtectedRoute = ({ children }) => {
  const isLoggedIn = !!localStorage.getItem("LoginToken"); // Check If Token Exists
  if (!isLoggedIn) {
    return <Navigate to="/" replace />; // Redirect To Login
  }
  return children; // Render The Protected Page
};
export default ProtectedRoute;
